import styled, { css } from 'styled-components';
import { yellow } from '@zocdoc/branding/colors';

const StickyHeaderStyles = css`
    left: 0;
    padding-top: 16px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1;
`;

export const StickySearchBarContainer = styled.div`
    background-color: ${yellow};
    padding-bottom: 20px;
    position: relative;

    ${props => props.isSticky ? StickyHeaderStyles : null}
`;
